import each from 'lodash/each';
import compact from 'lodash/compact';
import filter from 'lodash/filter';
import find from 'lodash/find';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

const mobileBreakpoint = 768;
const tabletBreakpoint = 1024;

const _ = {
  each,
  compact,
  filter,
  find,
  map,
  isEmpty,
};

function reduceVisualPersonalizationData(myFit, resultsState) {
  const dataByStyle = resultsState.visualPersonalizationDataByStyle;
  const productStyle = resultsState.currentStyle;
  const recommendedStyle = myFit ? myFit.bra_style : undefined;
  const productStylesMatch = productStyle === recommendedStyle;
  const currentStylePersonalizationData = dataByStyle[productStyle];
  const { size } = resultsState;
  const title = resultsState.visualPersonalizationModuleTitle;
  const featuresData = [];

  if (!currentStylePersonalizationData) {
    return false;
  }

  // generate featuresData object
  _.each(currentStylePersonalizationData, (featureDetails, featureName) => {
    let featureDetailsToSave;

    if (featureName === 'backgroundImages' || featureName === 'useLightColorFeatureTitle') {
      return; // ignore this object/property
    } else if (featureName === 'otherFeature') {
      featureDetailsToSave = featureDetails;
    } else { // featureDetails might depend on/be nested underneath fit issues
      const featureFitKey = `current${featureName[0].toUpperCase() + featureName.slice(1)}Fit`; // currentCupFit
      const featureFit = myFit && productStylesMatch ?
        myFit[featureFitKey]
          .replace('-a-little', '')
          .replace('-a-lot', '')
          .replace('good', 'default') : 'default'; // gaping, also replaces good with default

      // object or nested object
      const fitSpecificFeatureDetails = featureDetails[featureFit] || featureDetails.default;
      const useHalfCup = fitSpecificFeatureDetails.halfCup && size && size.indexOf('½') > -1;

      if (featureName === 'cup') {
        featureDetailsToSave = useHalfCup ? fitSpecificFeatureDetails.halfCup :
          fitSpecificFeatureDetails.wholeCup;
      } else {
        featureDetailsToSave = fitSpecificFeatureDetails;
      }
    }

    featuresData.push(featureDetailsToSave);
  });

  return {
    featuresData,
    title,
    backgroundImages: currentStylePersonalizationData.backgroundImages,
    useLightColorFeatureTitle: currentStylePersonalizationData.useLightColorFeatureTitle,
  };
}

function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(this, args);
    }.bind(this);
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(this, args);
  };
}

const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);

export {
  _,
  mobileBreakpoint,
  reduceVisualPersonalizationData,
  tabletBreakpoint,
  debounce,
  isMobileUserAgent,
}



// WEBPACK FOOTER //
// ./src/reactjs/shared/utils/common.js